var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('contract-header',{attrs:{"contract":_vm.contract}}),_vm._v(" "),_c('tabs',{attrs:{"nav-classes":['nav-tabs-linetriangle'],"store-module":_vm.moduleName}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fe5213d","hasScoped":true,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Customer/ContractManagement.vue
// module id = 1834
// module chunks = 0